export function assert(condition, message = 'assertion failed') {
    if (!condition) {
        throw new Error(message);
    }
}
export function debounce(callback, delay) {
    let timeout;
    return ((...args) => {
        if (timeout !== undefined) {
            clearTimeout(timeout);
        }
        timeout = setTimeout(() => {
            timeout = undefined;
            callback(...args);
        }, delay);
    });
}
//# sourceMappingURL=index.js.map